import { createSelector } from '@ngrx/store';
import { CostCodeStateInterface } from './cost-code.state';
import { getCostCodes } from '../../store/store.selectors';

export const getSelectedCostCodes = createSelector(
  getCostCodes,
  (state: CostCodeStateInterface) => state.costCodes
);
